module.exports = __webpack_public_path__ + "static/media/18_8.edc0b88d.png";